import { __assign } from 'tslib';
import Fuse from 'fuse.js';

var defaultOptions = {
    threshold: 0.5,
    minMatchCharLength: 1,
    useExtendedSearch: true,
};
/**
 * Creates FAQ search engine to search through the list of
 * faq items.
 *
 * @param faqItems List of faq items to search through
 */
function createFaqSearch(faqItems, options) {
    var fuse = new Fuse(faqItems, __assign(__assign(__assign({}, defaultOptions), { 
        // Allow for matches anywhere in the answer
        distance: Infinity, keys: [
            { name: 'question', weight: 0.7 },
            { name: 'answer', weight: 0.5 },
        ] }), options));
    /**
     * Get search results for given query
     *
     * @param query Search query
     * @param limit Search results limit
     */
    function search(query, limit) {
        if (limit === void 0) { limit = 24; }
        var searchQuery = (query || '').trim();
        return fuse
            .search("=" + searchQuery + " | '" + searchQuery + " | " + searchQuery, {
            limit: limit,
        })
            .map(function (result) {
            return result.item;
        });
    }
    return search;
}

export { createFaqSearch };
